const l = ":host{display:block;pointer-events:auto;animation:sl-toast-slide-in var(--sl-transition-normal) var(--sl-transition-timing-out)}:host(.sl-toast--removing){animation:sl-toast-slide-out var(--sl-transition-normal) var(--sl-transition-timing-in) forwards}.sl-toast{display:flex;align-items:flex-start;gap:var(--sl-spacing-3);padding:var(--sl-spacing-4);border-radius:var(--sl-radius-lg);border:1px solid hsl(var(--sl-hsl-border));background-color:hsl(var(--sl-hsl-background));color:hsl(var(--sl-hsl-foreground));box-shadow:var(--sl-shadow-lg);font-family:var(--sl-font-family-base);font-size:var(--sl-font-size-sm);min-width:min(18rem,calc(100vw - 2rem));max-width:min(24rem,calc(100vw - 2rem))}.sl-toast--success{border-color:hsl(var(--sl-hsl-success));background-color:hsl(var(--sl-hsl-background))}.sl-toast--error{border-color:hsl(var(--sl-hsl-destructive));background-color:hsl(var(--sl-hsl-background))}.sl-toast--warning{border-color:hsl(var(--sl-hsl-warning));background-color:hsl(var(--sl-hsl-background))}.sl-toast--info{border-color:hsl(var(--sl-hsl-info));background-color:hsl(var(--sl-hsl-background))}.sl-toast__icon{flex-shrink:0;width:1.25rem;height:1.25rem;margin-top:0.0625rem}.sl-toast__icon--success{color:hsl(var(--sl-hsl-success))}.sl-toast__icon--error{color:hsl(var(--sl-hsl-destructive))}.sl-toast__icon--warning{color:hsl(var(--sl-hsl-warning))}.sl-toast__icon--info{color:hsl(var(--sl-hsl-info))}.sl-toast__body{flex:1;min-width:0}.sl-toast__message{line-height:var(--sl-line-height-normal)}.sl-toast__close{flex-shrink:0;background:none;border:none;padding:0;width:1.25rem;height:1.25rem;display:flex;align-items:center;justify-content:center;cursor:pointer;color:hsl(var(--sl-hsl-muted-foreground));border-radius:var(--sl-radius-sm);font-size:1rem;transition:color var(--sl-transition-fast),background-color var(--sl-transition-fast);margin-top:0.0625rem}.sl-toast__close:hover{color:hsl(var(--sl-hsl-secondary-foreground));background-color:hsl(var(--sl-hsl-secondary))}@keyframes sl-toast-slide-in{from{opacity:0;transform:translateX(100%)}to{opacity:1;transform:translateX(0)}}@keyframes sl-toast-slide-out{from{opacity:1;transform:translateX(0);max-height:100px;margin-bottom:0.5rem}to{opacity:0;transform:translateX(100%);max-height:0;margin-bottom:0}}", n = {
  default: "",
  success: '<svg class="sl-toast__icon sl-toast__icon--success" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/></svg>',
  error: '<svg class="sl-toast__icon sl-toast__icon--error" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/></svg>',
  warning: '<svg class="sl-toast__icon sl-toast__icon--warning" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/></svg>',
  info: '<svg class="sl-toast__icon sl-toast__icon--info" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/></svg>'
};
class c extends HTMLElement {
  constructor() {
    super(), this._autoTimer = null, this._closeBtnHandler = null, this._shadow = this.attachShadow({ mode: "open" }), this._render();
  }
  static get observedAttributes() {
    return ["message", "variant", "duration", "dismissible"];
  }
  connectedCallback() {
    this._startAutoTimer();
  }
  disconnectedCallback() {
    this._autoTimer !== null && clearTimeout(this._autoTimer), this._closeBtnHandler && (this._shadow.querySelector(".sl-toast__close")?.removeEventListener("click", this._closeBtnHandler), this._closeBtnHandler = null);
  }
  attributeChangedCallback(s, t, o) {
    t !== o && this._render();
  }
  get message() {
    return this.getAttribute("message") || "";
  }
  set message(s) {
    this.setAttribute("message", s);
  }
  get variant() {
    return this.getAttribute("variant") || "default";
  }
  set variant(s) {
    this.setAttribute("variant", s);
  }
  get duration() {
    return parseInt(this.getAttribute("duration") || "3000", 10);
  }
  set duration(s) {
    this.setAttribute("duration", String(s));
  }
  get dismissible() {
    return this.hasAttribute("dismissible");
  }
  set dismissible(s) {
    s ? this.setAttribute("dismissible", "") : this.removeAttribute("dismissible");
  }
  dismiss() {
    this.classList.add("sl-toast--removing");
    const s = parseInt(
      getComputedStyle(this).getPropertyValue("--sl-transition-normal") || "250",
      10
    ) || 250;
    setTimeout(() => {
      this.dispatchEvent(new CustomEvent("dismiss", { bubbles: !0, composed: !0 })), this.remove();
    }, s);
  }
  _startAutoTimer() {
    this.duration > 0 && (this._autoTimer = setTimeout(() => {
      this.dismiss();
    }, this.duration));
  }
  _render() {
    const s = this.variant, t = ["sl-toast"];
    s !== "default" && t.push(`sl-toast--${s}`);
    const o = n[s] || "", a = this.dismissible ? '<button class="sl-toast__close" aria-label="Dismiss">×</button>' : "";
    this._shadow.innerHTML = `
      <style>${l}</style>
      <div class="${t.join(" ")}" role="alert" aria-live="polite">
        ${o}
        <div class="sl-toast__body">
          <div class="sl-toast__message">${this.message}</div>
        </div>
        ${a}
      </div>
    `;
    const i = this._shadow.querySelector(".sl-toast__close");
    i && (this._closeBtnHandler = () => this.dismiss(), i.addEventListener("click", this._closeBtnHandler));
  }
}
typeof customElements < "u" && !customElements.get("sl-toast") && customElements.define("sl-toast", c);
let r = null;
function d() {
  return (!r || !document.body.contains(r)) && (r = document.createElement("div"), r.style.cssText = [
    "position:fixed",
    "top:max(1rem, env(safe-area-inset-top, 0))",
    "right:max(1rem, env(safe-area-inset-right, 0))",
    "z-index:9999",
    "display:flex",
    "flex-direction:column",
    "gap:0.5rem",
    "pointer-events:none",
    "width:min(24rem, calc(100vw - 2rem))"
  ].join(";"), document.body.appendChild(r)), r;
}
function u(e) {
  const s = d(), t = document.createElement("sl-toast");
  return t.setAttribute("message", e.message), e.variant && t.setAttribute("variant", e.variant), e.duration !== void 0 && t.setAttribute("duration", String(e.duration)), e.dismissible && t.setAttribute("dismissible", ""), s.appendChild(t), t;
}
export {
  c as SlToastElement,
  u as showToast
};
//# sourceMappingURL=sl-toast.js.map
